import { render } from "./AOT_DMV_VT_HAUL_Logo.vue?vue&type=template&id=1cef137e"
import script from "./AOT_DMV_VT_HAUL_Logo.vue?vue&type=script&lang=js"
export * from "./AOT_DMV_VT_HAUL_Logo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__